<template>
    <div id="bonus_activity">
        <img src="@/assets/bonus/top_back.png" alt="">
        <div class="list_box">
            <div class="img_box">
                <img src="@/assets/bonus/5.png" alt="">
                <button class='bonus_open' @click="open"></button>
            </div>
            <div class="img_box">
                <img src="@/assets/bonus/10.png" alt="">
                <button class='bonus_open' @click="open"></button>
            </div>
            <div class="img_box">
                <img src="@/assets/bonus/15.png" alt="">
                <button class='bonus_open' @click="open"></button>
            </div>
            <div class="img_box">
                <img src="@/assets/bonus/20.png" alt="">
                <button class='bonus_open' @click="open"></button>
            </div>
            <div class="img_box">
                <img src="@/assets/bonus/50.png" alt="">
                <button class='bonus_open' @click="open"></button>
            </div>
        </div>
        <div class="content-box">
            <div class="part-one">
                <h1>活动说明：</h1>
            </div>
            <div class="part-one">
                <h1>赠金是平台赠送给用户的特殊资产，可在币安合约中作为本金使用。<br/>使用赠金进行合约交易，产生的收益将进入您的钱包余额中。</h1>
            </div>
            <div class="part-two">
                <h1>一、如何使用赠金？</h1>
                <p>
                    1、合约下单页面，切换至赠金账户后，点击“选择赠金”即可选择对应的赠金进行下单；（赠金和余额不可同时使用）<br/>
                    2、使用赠金的订单，系统将在开仓成功后24小时自动平仓，如需自行平仓，请提前操作；<br/>
                    3、同一交易对仅允许一笔赠金持仓，如需再次开仓请将现有持仓平掉后再进行操作；<br/>
                    4、赠金单次有效，不支持重复使用。
                </p>
            </div>
            <div class="part-three">
                <h1>二、赠金的使用条件</h1>
                <p>
                    1、每笔赠金都有“有效期”，请在期限内使用；<br/>
                    2、部分赠金对用户的累计充值金额或交易额有要求，达标后才可使用，请以具体赠金的要求为准；<br/>
                    3、使用赠金下单时，请注意“支持杠杆倍数”的限制，否则将无法使用。<br/>
                </p>
            </div>
            <div class="part-four">
                <h1>三、其它说明</h1>
                <p>
                    1、赠金是平台用以回馈用户的特殊奖励，请勿以违规手段获取赠金； <br/>
                    2、平台将严格审核用户信息，一经发现虚假、违规用户，将做封号处理。<br/>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BonusActivity",
    data() {
        return {
            bonusList: [5, 10, 15, 20, 50]
        }
    },
    methods: {
        open() {
            console.log('点击了')
            this.$setupWebViewJavascriptBridge(function(bridge) {
				bridge.callHandler('handleOpen', {data: {exchange: 'binance', cp: 'btc-usdt', isBonus: true}});
            }); 

            if (window.androidHandler) {  
                let str = JSON.stringify({params: 'trade', exchange: 'binance', cp: 'btc-usdt', isBonus: true});
                androidHandler.setValue(str);
            }
        },
    }
}
</script>

<style lang='less'>
#bonus_activity {
    // height: auto;
    min-height: 100vh;
	width: 100%;
    position: relative;
    background: #ffffff;
    font-family: PingFang SC;
    color: #33333A;
    img {
        width: 750px;
    }
    &.night{
        color: #E3E3E1;
        background: #181820;
        .content-box .line {
            background: #2A2A36;
        }
        .content-box {
            background: #181820;
        }
    }
    .list_box {
        margin-top: -154px;
        .img_box {
            position: relative;
            button {
                position: absolute;
                height: 120px;
                width: 200px;
                top: 50px;
                right: 50px;
                opacity: 0;
            }
        }
    }
    .content-box {
        text-align: left;
        z-index: 2;
        // position: absolute;
        top: 0;
        left: 0;
        padding: 70px 40px 40px 40px;
        h1 {
            font-size: 32px;
            font-weight: bold;
        }
        p {
            font-size: 28px;
            line-height: 42px;
        }
        .part-one {
            margin-bottom: 50px;
            h1 {
                line-height: 48px;
            }
        }
        .part-two {
            margin-bottom: 50px;
            h1 {
                line-height: 45px;
                margin-bottom: 20px;
            }
        }
        .part-three {
            margin-bottom: 50px;
            h1 {
                line-height: 45px;
                margin-bottom: 20px;
            }
        }
        .part-four {
            margin-bottom: 40px;
            h1 {
                line-height: 45px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>